module.exports = __webpack_public_path__ + "r-v3/img/sticker_23_icon.35ed6a79.svg";